module.exports = __webpack_public_path__ + "img/widget-novo-l.0d4495b7.png";